import { motion } from "framer-motion";
import { EASE } from "@/lib/scroll";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </Comp>
  );
};

export const Eyebrow = ({ index, children, light = false }) => (
  <div className={`flex items-center gap-4 text-[11px] uppercase tracking-[0.32em] font-medium ${light ? "text-gold-light" : "text-gold-deep"}`}>
    <span className="font-serif text-base italic tracking-normal normal-case">{index}</span>
    <span className={`h-px w-10 ${light ? "bg-gold-light/50" : "bg-gold/50"}`} />
    <span>{children}</span>
  </div>
);
